import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageLoader } from '@app/utils/storageLoader';

@Injectable({ providedIn: 'root' })
export class PaymentGateService {
  readonly profileGateOpen$ = new BehaviorSubject<boolean>(false);
  readonly addressGateOpen$ = new BehaviorSubject<boolean>(false);
  readonly addressFormGateOpen$ = new BehaviorSubject<boolean>(false);

  private profileResolver?: (granted: boolean) => void;
  private addressResolver?: (granted: boolean) => void;
  private addressFormResolver?: (saved: boolean) => void;

  constructor(private storageLoader: StorageLoader) {}

  async hasProfileComplete(): Promise<boolean> {
    try {
      const user = await this.storageLoader.getUser();
      return !!user && user.profile_complete === true;
    } catch {
      return false;
    }
  }

  async hasAddress(): Promise<boolean> {
    try {
      const user = await this.storageLoader.getUser();
      return !!user && user.have_address === true;
    } catch {
      return false;
    }
  }

  requireProfileComplete(): Promise<boolean> {
    if (this.profileResolver) {
      this.profileResolver(false);
      this.profileResolver = undefined;
    }

    return new Promise<boolean>((resolve) => {
      this.profileResolver = resolve;
      this.profileGateOpen$.next(true);
    });
  }

  onProfileCompleted(): void {
    this.profileGateOpen$.next(false);
    if (this.profileResolver) {
      this.profileResolver(true);
      this.profileResolver = undefined;
    }
  }

  onProfileClosed(): void {
    this.profileGateOpen$.next(false);
    if (this.profileResolver) {
      this.profileResolver(false);
      this.profileResolver = undefined;
    }
  }

  requireAddress(): Promise<boolean> {
    if (this.addressResolver) {
      this.addressResolver(false);
      this.addressResolver = undefined;
    }

    return new Promise<boolean>((resolve) => {
      this.addressResolver = resolve;
      this.addressGateOpen$.next(true);
    });
  }

  onAddressConfirmed(): void {
    this.addressGateOpen$.next(false);
    if (this.addressResolver) {
      this.addressResolver(true);
      this.addressResolver = undefined;
    }
  }

  onAddressDismissed(): void {
    this.addressGateOpen$.next(false);
    if (this.addressResolver) {
      this.addressResolver(false);
      this.addressResolver = undefined;
    }
  }

  requireAddressForm(): Promise<boolean> {
    if (this.addressFormResolver) {
      this.addressFormResolver(false);
      this.addressFormResolver = undefined;
    }

    return new Promise<boolean>((resolve) => {
      this.addressFormResolver = resolve;
      this.addressFormGateOpen$.next(true);
    });
  }

  onAddressFormCompleted(): void {
    this.addressFormGateOpen$.next(false);
    if (this.addressFormResolver) {
      this.addressFormResolver(true);
      this.addressFormResolver = undefined;
    }
  }

  onAddressFormDismissed(): void {
    this.addressFormGateOpen$.next(false);
    if (this.addressFormResolver) {
      this.addressFormResolver(false);
      this.addressFormResolver = undefined;
    }
  }
}
